<ion-app>
  <doka-header
    [environment]="environment.stage !== 'prod' ? environment.stage : undefined"
    rootPath="/return"
    (onClickLogin)="loginService.login()"
    [showMenuToggle]="true"
    [showNotifications]="true"
    [showLogo]="true"
    vcr
  >
    <doka-custom-header-action>
      <dot-branch-selection type="header"></dot-branch-selection>
    </doka-custom-header-action>
    <doka-language-context-menu [languages]="dokaTranslation.availableTranslations"></doka-language-context-menu>
    <doka-user-context-menu
      [user]="
        this.loginService.currentUser()
          ? {
              firstname: this.loginService.currentUser().firstname,
              lastname: this.loginService.currentUser().lastname,
              profilePictureUri: this.loginService.currentUser().profilePictureUrl,
              email: this.loginService.currentUser().email,
            }
          : undefined
      "
      [environment]="environment.production ? 'prod' : 'test'"
    >
      <doka-user-context-menu-entry
        (onAction)="this.loginService.logout()"
        icon="logout"
        label="{{ 'UserContext.Logout' | i18nextEager }}"
      ></doka-user-context-menu-entry>
    </doka-user-context-menu>
  </doka-header>

  <doka-app>
    <doka-menu [collapseOnNavigate]="true" [expanded]="true">
      <doka-menu-item route="/return">
        <ng-template #icon> home </ng-template>
        <ng-template #text> {{ "Nav.Home" | i18nextEager }} </ng-template>
      </doka-menu-item>
      <doka-menu-item route="/return/unloading">
        <ng-template #icon> forklift </ng-template>
        <ng-template #text> {{ "Return.Unloading.Overview.Title" | i18nextEager }} </ng-template>
      </doka-menu-item>
      <doka-menu-item route="/return/first-count">
        <ng-template #icon> visibility </ng-template>
        <ng-template #text> {{ "Return.FirstCount.Overview.Title" | i18nextEager }} </ng-template>
      </doka-menu-item>
      <doka-menu-item route="/return/grading">
        <ng-template #icon> edit </ng-template>
        <ng-template #text> {{ "Return.Grading.Overview.Title" | i18nextEager }} </ng-template>
      </doka-menu-item>
      <doka-menu-item route="/return/grading-check">
        <ng-template #icon> check </ng-template>
        <ng-template #text> {{ "Return.GradingCheck.Overview.Title" | i18nextEager }} </ng-template>
      </doka-menu-item>

      <doka-menu-item route="/settings" [pushDown]="true">
        <ng-template #icon> settings </ng-template>
        <ng-template #text> {{ "Nav.Settings" | i18nextEager }} </ng-template>
      </doka-menu-item>
    </doka-menu>
    <!-- <doka-navbar>
      <doka-navbar-item route="/delivery" label="{{ 'nav.delivery' | i18nextEager }}" icon="home"> </doka-navbar-item>
      <doka-navbar-item route="/return" label="{{ 'nav.return' | i18nextEager }}" icon="home"> </doka-navbar-item>
      <doka-navbar-item label="{{ 'nav.first' | i18nextEager }}" icon="settings" [route]="'/settings'">
      </doka-navbar-item>
    </doka-navbar> -->
    <doka-content>
      <ion-router-outlet></ion-router-outlet>
    </doka-content>
  </doka-app>
</ion-app>
